// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalHead__OH45N {
  min-height: 60px;
  display: flex;
  position: relative;
  align-items: center;
  padding: 20px 50px 20px 25px;
}
.modalHead__OH45N::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: var(--tables-primary-row-stroke);
  position: absolute;
  bottom: 0;
  left: 0;
}
.modalHead__OH45N::after {
  content: "";
  width: 42px;
  height: 3px;
  background-color: var(--brand-logo-surface);
  position: absolute;
  bottom: -1.5px;
  left: 0;
  z-index: 3;
}

.withoutSeparator__w_NDJ::before, .withoutSeparator__w_NDJ::after {
  content: none;
}

.modalHeadTitle__AshD6 {
  color: var(--header-title-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.closeIcon__cXXvE {
  position: absolute;
  top: 20px;
  right: 25px;
  cursor: pointer;
  stroke: var(--buttons-surface);
  transition: all 0.3s ease-in-out;
}

.rtl__PFXTl {
  right: unset;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ModalHeader/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AAzEF;AA2EE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,2CAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,UAAA;AA1EJ;;AA+EE;EAEE,aAAA;AA7EJ;;AAiFA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA9EF;;AAiFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;EACA,gCAAA;AA9EF;;AAiFA;EACE,YAAA;AA9EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalHead {\n  min-height: 60px;\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding: 20px 50px 20px 25px;\n\n  &::before {\n    content: '';\n    width: 100%;\n    height: 1px;\n    background-color: var(--tables-primary-row-stroke);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n\n  &::after {\n    content: '';\n    width: 42px;\n    height: 3px;\n    background-color: var(--brand-logo-surface);\n    position: absolute;\n    bottom: -1.5px;\n    left: 0;\n    z-index: 3;\n  }\n}\n\n.withoutSeparator {\n  &::before,\n  &::after {\n    content: none;\n  }\n}\n\n.modalHeadTitle {\n  color: var(--header-title-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.closeIcon {\n  position: absolute;\n  top: 20px;\n  right: 25px;\n  cursor: pointer;\n  stroke: var(--buttons-surface);\n  transition: all 0.3s ease-in-out;\n}\n\n.rtl {\n  right: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHead": `modalHead__OH45N`,
	"withoutSeparator": `withoutSeparator__w_NDJ`,
	"modalHeadTitle": `modalHeadTitle__AshD6`,
	"closeIcon": `closeIcon__cXXvE`,
	"rtl": `rtl__PFXTl`
};
module.exports = ___CSS_LOADER_EXPORT___;
